import { createContext, useContext, useMemo } from 'react';

import type { Website } from '../../../../front/src/types/api';

type BasePathContextType = {
  basePath: string;
};

const BasePathContext = createContext<BasePathContextType>({
  basePath: '/',
});

export const useBasePath = () => useContext(BasePathContext);

export const BasePathProvider = ({
  website,
  children,
}: {
  website: Website;
  children: React.ReactNode;
}) => {
  const basePath = useMemo(() => website?.graphdebate?.baseUrl || '/', [website]);

  return <BasePathContext.Provider value={{ basePath }}>{children}</BasePathContext.Provider>;
};
